import React, { useEffect, useState } from 'react';
import '@styles/commonStyles.css';
import {
  ContentContainer,
  DrawerTitleContainer,
  MainContainer,
  SummaryButton,
  SummaryText,
  ChevronIcon,
  SidebarContainer,
  CommitContainer,
  CommitText,
  DrawerContainer,
} from '@atoms/tableData/styles/contentContainer.styles';
import SubHeaderPL from '@atoms/subHeaderText/subHeaderPL';
import SideBar from '@templates/pursuitLeader/forecast/sideBarComponent/sideBar.component';
import PursuitLeaderTable from '@templates/pursuitLeader/forecast/tableComponent/pursuitLeaderTable';
import DashboardAlerts from '@organisms/alertBar/dashboardAlerts';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import DownChevron from '@assets/icons/down-chevron.png';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  Current_Page_Name,
  Now_Next_Beyond_Sidebar_Data_State,
  Recoil_Quarter_State,
  Recoil_Summary_Drawer_Toggle,
} from '../../recoil/recoil';
import { formatNumberWithKAndM } from '../../util/commonUtil';
import { isMobile, isTablet } from 'react-device-detect';
import { PAGE, PAGES_NAME } from '../../constants/commonConstants';

const PursuitLeaderForecast = () => {
  const [isOpen, setIsOpen] = useState(false);
  const nowNextBeyondSidebarData = useRecoilValue(Now_Next_Beyond_Sidebar_Data_State);
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const [currentMonthCommit, setCurrentMonthCommit] = useState(0);

  let currentQuartersMonthData;
  let currentMonthObject;

  const summaryDrawerToggle = useRecoilValue(Recoil_Summary_Drawer_Toggle);

  const setCurrentPageName = useSetRecoilState(Current_Page_Name);

  const screenWidth = window.innerWidth;

  useEffect(async () => {
    if (nowNextBeyondSidebarData !== null) {
      currentQuartersMonthData = nowNextBeyondSidebarData?.NOW?.quarterInfoData?.months;
      currentMonthObject = await findCurrentMonth(currentQuartersMonthData);
      setCurrentMonthCommit(currentMonthObject?.calculation?.commit);
    }
  }, [nowNextBeyondSidebarData]);

  useEffect(async () => {
    if (isOpen) toggleDrawer();
  }, [summaryDrawerToggle]);

  useEffect(() => {
    setCurrentPageName(PAGES_NAME.LIVE_FORECAST);
  }, []);

  const findCurrentMonth = data => {
    return data.find(item => item.calculation.period === 'current');
  };

  const toggleDrawer = () => {
    setIsOpen(isOpen => !isOpen);
  };

  return (
    <>
      <MainContainer>
        <ContentContainer
          className={(isMobile || isTablet) && screenWidth < 1170 ? 'mobileScroll' : null}
        >
          <SubHeaderPL />
          <DashboardAlerts screenName={PAGE.FORECAST} />
          <PursuitLeaderTable />
        </ContentContainer>

        <SummaryButton onClick={toggleDrawer}>
          <DrawerTitleContainer>
            <ChevronIcon
              src={DownChevron}
              alt="Expand Icon"
              className={!isOpen ? 'expanded' : 'collapsed'}
            />
            <SummaryText>Summary</SummaryText>
            {quarterInfo !== null && nowNextBeyondSidebarData !== null ? (
              <CommitContainer>
                <CommitText>Total {quarterInfo.month} Commit</CommitText>
                <CommitText> {formatNumberWithKAndM(currentMonthCommit)}</CommitText>
              </CommitContainer>
            ) : null}
          </DrawerTitleContainer>
        </SummaryButton>

        {/* Actual Drawer */}
        <DrawerContainer>
          {' '}
          <Drawer
            className="forecast-drawer"
            duration={250}
            onClose={toggleDrawer}
            direction="bottom"
            open={isOpen}
            overlayOpacity="0.6"
            zIndex={100}
          >
            <SideBar />
          </Drawer>
        </DrawerContainer>
        <SidebarContainer>
          <SideBar />
        </SidebarContainer>
      </MainContainer>
    </>
  );
};

export default PursuitLeaderForecast;
